var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import classNames from "classnames";
import * as userSettingsActions from "../../actions/userSettings";

import styles from "./UserSettings.css";

var ChangePassword = function (_Component) {
  _inherits(ChangePassword, _Component);

  function ChangePassword() {
    _classCallCheck(this, ChangePassword);

    var _this = _possibleConstructorReturn(this, (ChangePassword.__proto__ || Object.getPrototypeOf(ChangePassword)).call(this));

    _this.state = {
      password: "",
      password1: "",
      password2: ""
    };

    _this.changePassword = _this.changePassword.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  _createClass(ChangePassword, [{
    key: "handleChange",
    value: function handleChange(event) {
      this.setState(_defineProperty({}, event.target.name, event.target.value));
    }
  }, {
    key: "changePassword",
    value: function changePassword() {
      var _this2 = this;

      this.props.userSettingsActions.changePassword(this.state).then(function () {
        _this2.props.toggleChangePassword();
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(
        "div",
        { className: styles.grayOverlay },
        React.createElement(
          "div",
          { className: classNames(styles.createNewPasswordBox) },
          React.createElement(
            "h2",
            null,
            "Create a new password"
          ),
          React.createElement(
            "div",
            { className: styles.inputLabels },
            "Current password"
          ),
          React.createElement(
            "div",
            null,
            React.createElement("input", { onChange: this.handleChange, name: "password", className: styles.changePasswordInputs, type: "password", placeholder: "Type your current password", "aria-label": "Current Password" })
          ),
          React.createElement(
            "div",
            { className: styles.inputLabels },
            "New password"
          ),
          React.createElement(
            "div",
            null,
            React.createElement("input", { onChange: this.handleChange, name: "password1", className: styles.changePasswordInputs, type: "password", placeholder: "Type your new password", "aria-label": "New Password" })
          ),
          React.createElement(
            "div",
            { className: styles.inputLabels },
            "Confirm new password"
          ),
          React.createElement(
            "div",
            null,
            React.createElement("input", { onChange: this.handleChange, name: "password2", className: styles.changePasswordInputs, type: "password", placeholder: "Confirm your new password", "aria-label": "Confirm New Password" })
          ),
          React.createElement(
            "div",
            { className: styles.centerButtons },
            React.createElement(
              "button",
              { onClick: this.changePassword, className: classNames(styles.changePasswordConfirmButton, styles.blueButton1) },
              "Submit"
            )
          ),
          React.createElement(
            "div",
            { className: styles.centerButtons },
            React.createElement(
              "button",
              { onClick: this.props.toggleChangePassword, className: classNames(styles.cancelChangePasswordButton, styles.grayButton1) },
              "Cancel"
            )
          )
        )
      );
    }
  }]);

  return ChangePassword;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    userSettings: state.userSettings
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    userSettingsActions: bindActionCreators(userSettingsActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);


// WEBPACK FOOTER //
// ./src/users/components/UserSettings/ChangePassword.js